export default "__VITE_ASSET__04hf1sJD__"